import { Paper, Stack, Text, Title, TitleOrder } from '@mantine/core';

import { useGetApiAdminSettings } from '../../api/admin-settings/admin-settings';
import MaxWidthLayout from '../../components/utils/MaxWidthLayout';
import ServerLoadErrorFallback from '../../components/utils/ServerLoadErrorFallback';
import { LoadingFallBack } from '../utils/LoadingFallBack.tsx';
import { AdminOperations } from './AdminOperations.tsx';
import { Migrations } from './Migrations.tsx';

export const AdminSettings = () => {
    const {
        data: adminSettingsDto,
        isLoading: isLoadingAdminSettings,
        error: adminSettingsError,
        refetch: refetchAdminSettings
    } = useGetApiAdminSettings();

    if (adminSettingsError)
        return (
            <ServerLoadErrorFallback
                entity={'Admin Settings'}
                error={adminSettingsError}
            />
        );
    if (isLoadingAdminSettings || !adminSettingsDto?.dbReport)
        return <LoadingFallBack message={'Loading Admin Settings'} />;

    const getAdminSection = (
        title: string,
        children?: JSX.Element[] | JSX.Element,
        titleOrder: TitleOrder = 3
    ) => {
        return (
            <Paper p={'md'}>
                <Stack gap={'md'}>
                    <Title order={titleOrder}>{title}</Title>
                    {children && children}
                </Stack>
            </Paper>
        );
    };

    return (
        <MaxWidthLayout>
            <Stack gap={'md'}>
                {getAdminSection(
                    'Admin Settings',
                    <Text>
                        This page contains admin settings for the application.
                    </Text>,
                    2
                )}
                {getAdminSection(
                    'Database Migrations',
                    <Migrations
                        adminSettings={adminSettingsDto}
                        refetch={refetchAdminSettings}
                    />
                )}
                {getAdminSection(
                    'Actions',
                    <AdminOperations refetch={refetchAdminSettings} />
                )}
            </Stack>
        </MaxWidthLayout>
    );
};
